import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSettingsContext } from "../components/shared-components/settings";
import { allLangs, defaultLang } from "./config-lang";
import { localStorageGetItem } from "../utils/storage-available";

// ----------------------------------------------------------------------

export function useLocales() {
  const langStorage = localStorageGetItem("i18nextLng");

  const currentLang =
    allLangs.find((lang) => lang.value === langStorage) || defaultLang;

  localStorage.setItem("lang", currentLang.value);
  return {
    allLangs,
    currentLang,
  };
}

// ----------------------------------------------------------------------

type TextCase = "default" | "uppercase" | "lowercase" | "capitalize";

export function useTranslate() {
  const { i18n, ready, t } = useTranslation();
  const settings = useSettingsContext();

  const translate = useCallback(
    (key: string, textCase: TextCase = "default", options?: any): string => {
      const text = t(key, options); // Get translation

      if (typeof text !== "string") {
        console.error("Translation result is not a string:", text);
        return "";
      }

      switch (textCase) {
        case "uppercase":
          return text.toUpperCase();
        case "lowercase":
          return text.toLowerCase();
        case "capitalize":
          return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        default:
          return text;
      }
    },
    [t]
  );

  const onChangeLang = useCallback(
    (newlang: string) => {
      i18n.changeLanguage(newlang);
      settings.onChangeDirectionByLang(newlang);
    },
    [i18n, settings]
  );

  return {
    t: translate,
    i18n,
    ready,
    onChangeLang,
  };
}

